import * as React from 'react';
import itLocale from 'date-fns/locale/it';
import TextField from '@mui/material/TextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import DatePicker from '@mui/lab/DatePicker';
import LocalizationProvider from '@mui/lab/LocalizationProvider';

const localeMap = {
  it: itLocale
};

const maskMap = {
  it: '__/__/____'
};

// Selettore Data
// PROPS
// data: stringa che rappresenta la data iniziale del componente
// handleOnChange: funzione callback quando la data del componente cambia 

export default function LocalizedDatePicker(props) {
  const [locale, ] = React.useState('it');
  const [value, setValue] = React.useState(Date.parse(props.data));


  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={localeMap[locale]}>
        <DatePicker
          mask={maskMap[locale]}
          value={value}
          onChange={(newValue) => {props.handleOnChange(newValue); setValue(newValue)}}
          renderInput={(params) => <TextField {...params} />}
        />
    </LocalizationProvider>
  );
}
